<template>
    <div class="mb-3">
        <SGPFormSelectComponent 
            :name="'user_id'"
            :listaDeOptions="listaDeUsuarios"
            v-model="user_id"
            :optionLabel="'name'"
            :placeholder="'Nome do Usuário'"
            data-vv-as="Nome do Usuário"
            @change="atualizarListagemUsuarios($event)"
        />
        <div v-if="usuario.name">
            <div class="container align-self-center d-flex justify-content-center ">
                <span class="nome-avatar rounded-circle">
                <strong>{{ nomeAvatar }}</strong>
                </span>
            </div>
            <div class="container align-self-center d-flex justify-content-center">
                {{ nomeCompleto }}
            </div>
            <SGPRowComponent class="flex-row justify-content-center">
                <SGPColComponent cols="7">
                    <template>
                    <v-expansion-panels>
                        <v-expansion-panel>
                        <v-expansion-panel-header>
                            <SGPRowComponent no-gutters>
                            <SGPColComponent cols="4">
                                <h3 class="titulo">Cadastro do Usuário</h3>
                            </SGPColComponent>
                            </SGPRowComponent>
                            <template v-slot:actions>
                            <v-icon color="primary" large dark>
                                mdi-arrow-down-drop-circle
                            </v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <hr>
                            <CadastroUsuarioComponent :usuario="usuario" />
                        </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel v-if="usuario.perfis.length">
                        <v-expansion-panel-header>
                            <SGPRowComponent no-gutters>
                            <SGPColComponent cols="4">
                                <h3 class="titulo">Perfil Aplicação OEM</h3>
                            </SGPColComponent>
                            </SGPRowComponent>
                            <template v-slot:actions>
                            <v-icon color="primary" large dark>
                                mdi-arrow-down-drop-circle
                            </v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <hr>
                            <h3 class="mb-6"><strong>Perfis Ativos</strong></h3>
                            <PerfilAplicacaoComponent v-for="(perfil, index) in usuario.perfis" :key="index" :perfil="perfil" />
                            <SGPAlertaComponent v-if="!usuario.perfis.length">Sem perfil configurado</SGPAlertaComponent>
                        </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel v-if="tarefas.length || regionais.length">
                        <v-expansion-panel-header>
                            <SGPRowComponent no-gutters>
                            <SGPColComponent cols="4">
                                <h3 class="titulo">Perfil Workflow - SGP</h3>
                            </SGPColComponent>
                            </SGPRowComponent>
                            <template v-slot:actions>
                            <v-icon color="primary" large dark>
                                mdi-arrow-down-drop-circle
                            </v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <hr>
                            <h4 class="mb-6">Tarefas Configuradas</h4>
                            <TarefaConfiguradaComponent v-for="(tarefa, index) in tarefas" :key="index" :tarefa="tarefa" />
                            <SGPAlertaComponent v-if="!tarefas.length">Sem tarefas configuradas</SGPAlertaComponent>
                            <br>
                            <h4 class="mb-6">Regionais Configuradas</h4>
                            <RegionalConfiguradaComponent v-for="(regional, index) in regionais" :key="index" :regional="regional" />
                            <SGPAlertaComponent v-if="!regionais.length">Sem regionais configuradas</SGPAlertaComponent>
                        </v-expansion-panel-content>
                        </v-expansion-panel>
                    
                        <v-expansion-panel v-if="equipes.length">
                        <v-expansion-panel-header>
                            <SGPRowComponent no-gutters>
                            <SGPColComponent cols="4">
                                <h3 class="titulo">Equipes</h3>
                            </SGPColComponent>
                            </SGPRowComponent>
                            <template v-slot:actions>
                            <v-icon color="primary" large dark>
                                mdi-arrow-down-drop-circle
                            </v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <hr>
                            <EquipeComponent v-for="(equipe, index) in equipes" :key="index" :equipe="equipe" />
                            <SGPAlertaComponent v-if="!equipes.length">Sem equipes configuradas</SGPAlertaComponent>
                        </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    </template>
                </SGPColComponent>
            </SGPRowComponent>
        </div>
        
        
            <SGPLoadingComponent v-if="loadingUsuario" />
    </div>
    
</template>
    


<script>
import { mapActions, mapGetters } from 'vuex'
import CadastroUsuarioComponent from "../components/MeuPerfil/CadastroUsuarioComponent.vue";
import PerfilAplicacaoComponent from "../components/MeuPerfil/PerfilAplicacaoComponent.vue";
import TarefaConfiguradaComponent from "../components/MeuPerfil/TarefaConfiguradaComponent.vue";
import RegionalConfiguradaComponent from "../components/MeuPerfil/RegionalConfiguradaComponent.vue";
import EquipeComponent from "../components/MeuPerfil/EquipeComponent.vue";
import SGPLoadingComponent from '../../../../common/sgp-components/SGPLoadingComponent.vue';
export default {
components: { CadastroUsuarioComponent, PerfilAplicacaoComponent, TarefaConfiguradaComponent, RegionalConfiguradaComponent, EquipeComponent, SGPLoadingComponent },
name: 'ExibePerfilPage',
created () {
    let user_id = 1;
    this.getUsuario(user_id);
    this.listarUsuarios();
    this.getTarefasUsuario(user_id);
    this.getRegionaisUsuario(user_id);
    this.getEquipesUsuario(user_id);
    
},

computed: {
    ...mapGetters('usuarios', ['loadingUsuario','usuario','usuarioSelecionado','listaDeUsuarios', "tarefas", "regionais", "equipes"]),
    nomeAvatar() {
        const nome = this.usuario.name.split(' ');
        const primeiroNome = nome[0]
        let ultimoNome = nome[nome.length - 1]

        if (nome.length == 1) {
            ultimoNome = primeiroNome[1]
        }

        return `${primeiroNome[0]}${ultimoNome[0]}`;
    },
    nomeCompleto() {
        const nomeC = this.usuario.name;
        return nomeC;
    }
},
methods: {
...mapActions('usuariosPerfisSgp', [ 'listarUsuarioComPerfis', 'associarPerfisAoUsuario' ]),
...mapActions('usuarios', [ 'getUsuario','listarUsuarios', 'getTarefasUsuario', 'getRegionaisUsuario', 'getEquipesUsuario'  ]),

    async atualizarListagemUsuarios(event) {
        if(typeof event == 'undefined'){
        return false;
        } 
        
        this.getUsuario(this.user_id);

        
        let user_id = this.user_id;

        this.getTarefasUsuario(user_id);
        this.getRegionaisUsuario(user_id);
        this.getEquipesUsuario(user_id);
    }
}
}
</script>
<style scoped>
.nome-avatar {
width: 80px;
height: 80px;
background-color: lightgray;
font-size: 40px
}

.titulo {
color: dimgray;
}

div span {
display: flex;
justify-content: center;
align-items: center;
width: 100px;
height: 100px;
float: left;
}

label {
font-size: 22px
}
</style>